module.exports = UpdateAppURLHelper = (adjustedURL, opts={}) ->
  if usePushState(opts)
    window.history.pushState(null, null, adjustedURL)
  else if window.history?.replaceState?
    window.history.replaceState(null, null, adjustedURL)
  else
    window.location = adjustedURL

usePushState = (opts) ->
  return false unless opts.pushState
  window.history?.pushState?
